import { selectBoothTierById, selectTierNameById } from 'models/cms/boothTiers';
import { useMemo } from 'react';
import { shallowEqual, useSelector } from 'react-redux';

const BOOTH_BASE_WIDTH = 330;

const determineScale = (scale) => {
  switch (scale?.unit) {
    case 'PERCENT':
      return scale?.dimension / 100;
    case 'PIXEL':
      return scale?.dimension / BOOTH_BASE_WIDTH;
    default: return 1.0;
  }
};

const useBoothTier = (tierId: string) => {
  const boothTier = useSelector((state) => selectBoothTierById(state, tierId), shallowEqual);
  const tierName = useSelector((state) => selectTierNameById(state, tierId), shallowEqual);
  const tierScale = determineScale(boothTier?.scale);

  return useMemo(() => ({
    tierName,
    tierScale,
  }), [tierName, tierScale]);
};

export default useBoothTier;
